import React, { useState, useEffect, useRef } from "react";
import { Form } from "react-bootstrap";

const CreateTableCheckBoxInput = (props) => {
  const { field } = props;
  const [inputValue, setInputValue] = useState(false);
  const myRef = useRef(null);

  useEffect(() => {
    if (field) {
      if (field.checked && field.checked === "true") {
        const component = myRef.current;
        if (component) component.checked = true;
      }
      if (field.value) setInputValue(field.value);
    }
  }, [field]);

  return (
    <Form.Group
      controlId={`formCheck-${field.variable}`}
      key={field.variable}
      style={{ marginBottom: "0px" }}
    >
      {field.disabled === "true" || field.readonly === "true" ? (
        <input
          ref={myRef}
          type="checkbox"
          name={field.name}
          value={inputValue}
          style={{ paddingTop: "0px", paddingBottom: "0px" }}
          disabled
        />
      ) : (
        <input
          ref={myRef}
          type="checkbox"
          name={field.name}
          value={inputValue}
          style={{ paddingTop: "0px", paddingBottom: "0px" }}
          onChange={(event) => setInputValue(event.target.checked)}
        />
      )}
    </Form.Group>
  );
};

export default CreateTableCheckBoxInput;
